import { render, staticRenderFns } from "./ProductTypeChildrenTab.vue?vue&type=template&id=0c36b700&scoped=true&"
import script from "./ProductTypeChildrenTab.vue?vue&type=script&lang=ts&"
export * from "./ProductTypeChildrenTab.vue?vue&type=script&lang=ts&"
import style0 from "./ProductTypeChildrenTab.vue?vue&type=style&index=0&id=0c36b700&scoped=true&lang=css&"
import style1 from "./ProductTypeChildrenTab.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c36b700",
  null
  
)

export default component.exports